<template>
  <div id="app">
    <router-view class="view"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      auth: false
    }
  },
  created: function () {
  }
}
</script>




// WEBPACK FOOTER //
// App.vue?104f325c